import type { BuilderNode } from '@nsb/core';
import type { StepMarkKind } from '../drawings.tsx';

/** The drawing's mark for a step of the process tree: a task someone outside does takes the inspection's. */
export const markOf = (n: Pick<BuilderNode, 'kind' | 'who'>): StepMarkKind => (n.kind === 'task' ? (n.who === 'outside' ? 'inspection' : 'work') : n.kind);
